import { render, staticRenderFns } from "./RssUpgradeAlert.vue?vue&type=template&id=67dd6956"
import script from "./RssUpgradeAlert.vue?vue&type=script&lang=js"
export * from "./RssUpgradeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports